import type { ArticleBlock } from '../entities/article';

interface TemplateFeatures {
  useNewTemplate: boolean;
  hasTaboola: boolean;
  hasInfiniteScroll: boolean;
  hasLeadGenWidget: boolean;
}

export const getTemplateFeatures = (_articleId: string): TemplateFeatures => ({
  hasInfiniteScroll: true,
  hasLeadGenWidget: true,
  hasTaboola: false,
  useNewTemplate: true,
});

export const countElementsInBodyBlocks = (articleBlocks: ArticleBlock[], elementTagName: string): number => {
  if (Array.isArray(articleBlocks)) {
    return articleBlocks.filter(item => item?.tag === elementTagName)?.length || 0;
  }

  return 0;
};
